export const THEME_CONSTANTS = {
  toolbarHeight: '64px',
  darkenImageBrightness: 'brightness(30%)',
  mobileToolbarHeight: '0px'
}
